import { render, staticRenderFns } from "./workerWageLevel.vue?vue&type=template&id=00ab4c29&"
import script from "./workerWageLevel.vue?vue&type=script&lang=js&"
export * from "./workerWageLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports